/**
 * /app-signin (fd-rich-chat PH-06w): in Chrome, signed in, one button hands the sign-in to the Jarvis app. Signed out,
 * the ordinary prompt; after it, this screen.
 */
import { api } from '../api/client';
import { AuthPrompt } from './AuthPrompt';
import { appSigninHref } from './app-signin';
import { isAuthenticated } from './store';

export function AppSignIn() {
  if (!isAuthenticated.value || !api.getToken()) return <AuthPrompt />;
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>J</div>
        <h2 style={styles.title}>Sign in the Jarvis app</h2>
        <p style={styles.subtitle}>One tap gives the Jarvis app the sign-in this browser already has. It stays on this phone.</p>
        <a href={appSigninHref(api.getToken())} style={styles.button}>Open the Jarvis app signed in</a>
        <a href="/chat" style={styles.quiet}>Stay here</a>
      </div>
    </div>
  );
}

const styles: Record<string, Record<string, string | number>> = {
  container: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100dvh',
    background: 'var(--bg-primary)', padding: '24px' },
  card: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', width: '100%', maxWidth: '360px',
    padding: '40px 24px', background: 'var(--bg-secondary)', borderRadius: 'var(--radius)', border: '1px solid var(--border)',
    textAlign: 'center' },
  logo: { width: '56px', height: '56px', borderRadius: '50%', background: 'var(--accent)', color: 'white', fontSize: '28px',
    fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' },
  title: { fontSize: '20px', fontWeight: '700', color: 'var(--text-primary)', margin: '0 0 6px' },
  subtitle: { fontSize: '14px', lineHeight: '1.45', color: 'var(--text-secondary)', margin: '0 0 22px' },
  button: { display: 'block', width: '100%', boxSizing: 'border-box', padding: '13px', borderRadius: 'var(--radius-sm)',
    background: 'var(--accent)', color: 'white', fontSize: '15px', fontWeight: '600', textDecoration: 'none' },
  quiet: { marginTop: '14px', fontSize: '14px', color: 'var(--text-secondary)', textDecoration: 'none' },
};
